import { TRPCPost } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import {
  IGetDistributionKeysReq,
  IGetDistributionKeysRsp,
  IGetTrendReq,
  IGetTrendRsp,
  ITrend,
  IDistribution,
  // IGetDistributionReq,
  IGetDistributionRsp, IKey,
} from '@/proto/statistics';

export interface IGetDistribution {
  distributions: IDistribution[],
  validReportedCount?: number;
  validDeviceUv?: number;
  validUserUv?: number;
}

export const getIssueTrend = async (params: IGetTrendReq): Promise<ITrend[]> => {
  try {
    const resp = await TRPCPost<IGetTrendRsp>(
      `/${API_PREFIX}/trpc/trpc.rmonitor.web_server.IssueStatistics/GetTrend`,
      params,
    );

    return resp?.trends || [];
  } catch (e) {
    logger.error('getIssueTrend e:', e);
    return [];
  }
};

/**
 * 获取指标keys
 * @returns
 */
export const getDistributionKeys = async (params: IGetDistributionKeysReq): Promise<IKey[]> => {
  try {
    const res = await TRPCPost<IGetDistributionKeysRsp>(
      `/${API_PREFIX}/trpc/trpc.rmonitor.web_server.IssueStatistics/GetDistributionKeys`,
      params,
    );

    return res?.keys || [];
  } catch (e) {
    logger.error('getDistributionKeys e:', e);
    return [];
  }
};

/**
 * 按指标获取统计分布数据
 * @returns
 */
export const getDistributions = async (params: any): Promise<IGetDistribution> => {
  // TODO 类型改回来
  try {
    const resp = await TRPCPost<IGetDistributionRsp>(
      `/${API_PREFIX}/trpc/trpc.rmonitor.web_server.IssueStatistics/GetDistribution`,
      params,
    );
    return {
      distributions: resp?.distributions || [],
      validReportedCount: resp.validReportedCount,
      validDeviceUv: resp.validDeviceUv,
      validUserUv: resp.validUserUv,
    };
  } catch (e) {
    logger.error('getDistributions:', e);
    return {
      distributions: [],
    };
  }
};
